/* eslint-disable react/prop-types */
import _ from 'lodash';
import moment from 'moment';

//NOT USED. COMES IN
const ADDER_MAP = {
	ncpSanYsidro: 0,
	opisFlat: 0,
	ncpSacramento: 0.02,
	rpmg: 0.02,
	//pdi : 0.0374, //- changed on 1/9/2019
	pdi: 0.0439,
	//gm: -0.03,
	//gm: 0.0, // changed 3/1/23
	// gm: 0.01, // changed 3/7/23
	//gm: 0.02, // changed 3/30/23
	gm: 0.05, // changed 3/30/23
	notUsed: 0,
	kinergy: 0.03,
	//kinergyForBoyett: -0.11,
	kinergyForBoyett: -0.08,
};

const BULK_ADDER_MAP = {
	//boyett : 0.0755,      //- Q2_2019
	boyett: -0.01, //- Updated 6/30 Q3_2019
	idemitsu: 0.02,
	//rcp : 0.0755,         //- Q2_2019
	rcp: -0.01, //- Updated 6/30 Q3_2019
	scFuels: -0.085, //- Updated 10/1 Q3_2019
	seaportRefining: 0,
	musketMissionValley: 0.055,
	musketColton: 0.035,
	shell: -0.2, //- Updated 7/12/2019 minus 20 cents. Missed on contract.
};

function getRackAdderMap(data) {
	return data.rackAdderMap || ADDER_MAP;
}

function getBulkAdderMap(data) {
	return data.bulkAdderMap || BULK_ADDER_MAP;
}

// const RIN_CREDIT_JUNE = 0.47;
// const RIN_CREDIT_JUNE_LABEL = 'RIN June Credit';
const PRIOR_DAY_LABEL = 'LA Spot Ethanol Cost';
const PROJECTED_LABEL = 'Projected Monthly LA Ethanol Cost';
const UP_TO_DATE_LABEL = 'MTD Average LA Ethanol Cost';
const E85_PRICE_LABEL = 'E85 Price';
const RACK_PRIOR_LABEL = 'Rack LA Spot Ethanol Cost';
const RACK_PROJ_LABEL = 'Rack Projected LA Ethanol Cost';
const RACK_UP_TO_DATE_LABEL = 'Rack Projected Average LA Ethanol Cost';

// UNL
const LA_UNL_RACK_AVG_OPENING = 'LA Carb 87 Rack Average (opening)';
const LA_UNL_RACK_AVG_CLOSING = 'LA Carb 87 Rack Average (closing)';

// LCFS
// NOte these values should ALWAYS come from the API starting 7/1/205 but
// putting them here as a fallback
const LCFS_TARGET = 85.77; // 07/01/2025
const LCFS_STANDARD = 76.6; // 07/01/2025

//- Needs to switch Feb 1st
const use2026RinAfterDate = moment('2026-01-01');
const use2025RinAfterDate = moment('2025-01-01');
const use2024RinAfterDate = moment('2024-01-01');
const use2023RinAfterDate = moment('2023-01-01');
const use2022RinAfterDate = moment('2022-01-01');
const use2021RinAfterDate = moment('2021-01-01');
const use2020RinAfterDate = moment('2020-01-01');
const use2019RinAfterDate = moment('2019-01-01');

function getRinField(data) {
	// We started saving this to the data dumps on feb 4th.
	if (data.currentRinField) {
		return data.currentRinField;
	}

	const dataDate = moment(data.date);

	if (dataDate.isAfter(use2026RinAfterDate)) {
		return 'rinCredit2026';
	} else if (dataDate.isAfter(use2025RinAfterDate)) {
		return 'rinCredit2025';
	} else if (dataDate.isAfter(use2024RinAfterDate)) {
		return 'rinCredit2024';
	} else if (dataDate.isAfter(use2023RinAfterDate)) {
		return 'rinCredit2023';
	} else if (dataDate.isAfter(use2022RinAfterDate)) {
		return 'rinCredit2022';
	} else if (dataDate.isAfter(use2021RinAfterDate)) {
		return 'rinCredit2021';
	} else if (dataDate.isAfter(use2020RinAfterDate)) {
		return 'rinCredit2020';
	} else if (dataDate.isAfter(use2019RinAfterDate)) {
		return 'rinCredit2019';
	} else {
		return 'rinCredit2025';
	}
}

//const currentRinLabel = 'RIN Credit 2023';
function getRinLabel(currentRinField) {
	if (currentRinField === 'rinCredit2026') {
		return 'RIN Credit 2026';
	} else if (currentRinField === 'rinCredit2025') {
		return 'RIN Credit 2025';
	} else if (currentRinField === 'rinCredit2024') {
		return 'RIN Credit 2024';
	} else if (currentRinField === 'rinCredit2023') {
		return 'RIN Credit 2023';
	} else if (currentRinField === 'rinCredit2022') {
		return 'RIN Credit 2022';
	} else if (currentRinField === 'rinCredit2021') {
		return 'RIN Credit 2021';
	} else if (currentRinField === 'rinCredit2020') {
		return 'RIN Credit 2020';
	} else if (currentRinField === 'rinCredit2019') {
		return 'RIN Credit 2019';
	} else {
		return 'RIN Credit 2025';
	}
}

/*
Was used by alfred but not anymore
function shouldIUseProjectedOverSpot(data) {
	return data.projectedMonthly.laEth > data.laEth;
}

function _higherLaEth(data) {
	let val;
	if (shouldIUseProjectedOverSpot(data)) {
		val = data.projectedMonthly.laEth;
	} else {
		val = data.laEth;
	}

	// NORMAL
	// return val;
	return val;
}


function _lowerRin(data) {
	const currentRinField = getRinField(data);
	return data.projectedMonthly[currentRinField] < data[currentRinField]
		? data.projectedMonthly[currentRinField]
		: data[currentRinField];
}


	*/

function getEthToUse(data) {
	const spot = data.laEth;
	const proj = data.projectedMonthly.laEth;
	const toDate = data.upToDateMonthly?.laEth;

	if (spot >= proj && spot >= toDate) {
		return { ethCostType: 'latest spot', ethCost: spot };
	} else if (proj >= spot && proj >= toDate) {
		return { ethCostType: 'projected monthly', ethCost: proj };
	} else if (toDate >= spot && toDate >= proj && toDate) {
		return { ethCostType: 'mtd average', ethCost: toDate };
	} else {
		return { ethCostType: 'latest spot?', ethCost: spot };
	}
}

function getRinToUse(data) {
	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);

	const spot = data[currentRinField];
	const proj = data.projectedMonthly[currentRinField];
	const toDate = data.upToDateMonthly[currentRinField];

	if (spot <= proj && spot <= toDate) {
		return { rinCreditType: 'latest spot', rinCredit: spot, currentRinLabel };
	} else if (proj <= spot && proj <= toDate) {
		return { rinCreditType: 'projected monthly', rinCredit: proj, currentRinLabel };
	} else if (toDate <= spot && toDate <= proj) {
		return { rinCreditType: 'mtd average', rinCredit: toDate, currentRinLabel };
	} else {
		return { rinCreditType: 'latest spot?', rinCredit: spot, currentRinLabel };
	}
}

//
//- RACK FORMULAS
//
const isSubtotal = true;
const isTitle = true;
const isTotal = true;
const notImplemented = true;

const kinergy = ({ data }) => {
	const rackAdderMap = getRackAdderMap(data);
	const ethCost = data.priorWeek.laEth + rackAdderMap.kinergy;

	const formulaRows = [
		{ label: 'Kinergy Ethanol Cost Formula', isTitle },

		{ label: 'Prior Week Ethanol', value: data.priorWeek.laEth },
		{ label: 'Kinergy Adder', value: rackAdderMap.kinergy },
		{ label: RACK_PRIOR_LABEL, value: ethCost, isSubtotal },

		{ label: 'Prior Week Ethanol', value: data.priorWeek.laEth },
		{ label: 'Kinergy Adder', value: rackAdderMap.kinergy },
		{ label: RACK_PROJ_LABEL, value: ethCost, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: ethCost, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: ethCost, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: ethCost, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const kinergyForBoyett = ({ data }) => {
	const rackAdderMap = getRackAdderMap(data);
	const ethCost = data.priorWeek.laEth + rackAdderMap.kinergyForBoyett;

	const formulaRows = [
		{ label: 'Kinergy for Boyett Ethanol Cost Formula', isTitle },

		{ label: 'Prior Week Ethanol', value: data.priorWeek.laEth },
		{ label: 'Kinergy for Boyett Adder', value: rackAdderMap.kinergyForBoyett },
		{ label: RACK_PRIOR_LABEL, value: ethCost, isSubtotal },

		{ label: 'Prior Week Ethanol', value: data.priorWeek.laEth },
		{ label: 'Kinergy for Boyett Adder', value: rackAdderMap.kinergyForBoyett },
		{ label: RACK_PROJ_LABEL, value: ethCost, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: ethCost, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: ethCost, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: ethCost, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const opisFlat = ({ data }) => {
	const laEth = data.laEth;
	const projectedMonthlyLaEth = data.projectedMonthly.laEth;
	const upToDateMonthlyLaEth = data.upToDateMonthly?.laEth;

	const formulaRows = [
		{ label: 'OPIS Flat Ethanol Cost Formula', isTitle },
		{ label: PRIOR_DAY_LABEL, value: data.laEth },
		{ label: RACK_PRIOR_LABEL, value: laEth, isSubtotal },

		{ label: PRIOR_DAY_LABEL, value: data.projectedMonthly.laEth },
		{ label: RACK_PROJ_LABEL, value: projectedMonthlyLaEth, isSubtotal },

		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth },
		{ label: RACK_UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: laEth, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: projectedMonthlyLaEth, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const ncpSanYsidro = ({ data }) => {
	const laEth = data.laEth;
	const projectedMonthlyLaEth = data.projectedMonthly.laEth;
	const upToDateMonthlyLaEth = data.upToDateMonthly?.laEth;

	const formulaRows = [
		{ label: 'NCP San Ysidro Ethanol Cost Formula', isTitle },
		{ label: PRIOR_DAY_LABEL, value: data.laEth },
		{ label: RACK_PRIOR_LABEL, value: laEth, isSubtotal },

		{ label: PRIOR_DAY_LABEL, value: data.projectedMonthly.laEth },
		{ label: RACK_PROJ_LABEL, value: projectedMonthlyLaEth, isSubtotal },

		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth },
		{ label: RACK_UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: laEth, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: projectedMonthlyLaEth, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const ncpSacramento = ({ data }) => {
	const rackAdderMap = getRackAdderMap(data);
	const adder = rackAdderMap.ncpSacramento;
	const laEth = data.laEth + adder;
	const projectedMonthlyLaEth = data.projectedMonthly.laEth + adder;
	const upToDateMonthlyLaEth = data.upToDateMonthly?.laEth + adder;

	const formulaRows = [
		{ label: `NCP Sacramento Ethanol Cost Formula`, isTitle },

		{ label: PRIOR_DAY_LABEL, value: data.laEth },
		{ label: 'NCP Sacramento Adder', value: rackAdderMap.ncpSacramento },
		{ label: RACK_PRIOR_LABEL, value: laEth, isSubtotal },

		{ label: PROJECTED_LABEL, value: data.projectedMonthly.laEth },
		{ label: 'NCP Sacramento Adder', value: rackAdderMap.ncpSacramento },
		{ label: RACK_PROJ_LABEL, value: projectedMonthlyLaEth, isSubtotal },

		{ label: UP_TO_DATE_LABEL, value: data.upToDateMonthly?.laEth },
		{ label: 'NCP Sacramento', value: adder },
		{ label: RACK_UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: laEth, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: projectedMonthlyLaEth, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const rpmg = ({ data }) => {
	const rackAdderMap = getRackAdderMap(data);
	const adder = rackAdderMap.rpmg;
	const laEth = data.laEth + adder;
	const projectedMonthlyLaEth = data.projectedMonthly.laEth + adder;
	const upToDateMonthlyLaEth = data.upToDateMonthly?.laEth + adder;

	const formulaRows = [
		{ label: `RPMG Ethanol Cost Formula`, isTitle },

		{ label: PRIOR_DAY_LABEL, value: data.laEth },
		{ label: 'RPMG Adder', value: adder },
		{ label: RACK_PRIOR_LABEL, value: laEth, isSubtotal },

		{ label: PROJECTED_LABEL, value: data.projectedMonthly.laEth },
		{ label: 'RPMG Adder', value: adder },
		{ label: RACK_PROJ_LABEL, value: projectedMonthlyLaEth, isSubtotal },

		{ label: UP_TO_DATE_LABEL, value: data.upToDateMonthly?.laEth },
		{ label: 'RPMG Adder', value: adder },
		{ label: RACK_UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: laEth, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: projectedMonthlyLaEth, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const pdi = ({ data }) => {
	const rackAdderMap = getRackAdderMap(data);
	const adder = rackAdderMap.pdi;
	const laEth = data.laEth + adder;
	const projectedMonthlyLaEth = data.projectedMonthly.laEth + adder;
	const upToDateMonthlyLaEth = data.upToDateMonthly?.laEth + adder;

	const formulaRows = [
		{ label: `PDI Ethanol Cost Formula`, isTitle },

		{ label: PRIOR_DAY_LABEL, value: data.laEth },
		{ label: 'PDI Adder', value: adder },
		{ label: RACK_PRIOR_LABEL, value: laEth, isSubtotal },

		{ label: PROJECTED_LABEL, value: data.projectedMonthly.laEth },
		{ label: 'PDI Adder', value: adder },
		{ label: RACK_PROJ_LABEL, value: projectedMonthlyLaEth, isSubtotal },

		{ label: UP_TO_DATE_LABEL, value: data.upToDateMonthly?.laEth },
		{ label: 'PDI Adder', value: adder },
		{ label: RACK_UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: laEth, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: projectedMonthlyLaEth, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

const gm = ({ data }) => {
	const rackAdderMap = getRackAdderMap(data);
	const adder = rackAdderMap.gm;
	const laEth = data.laEth + adder;
	const projectedMonthlyLaEth = data.projectedMonthly.laEth + adder;
	const upToDateMonthlyLaEth = data.upToDateMonthly?.laEth + adder;

	const formulaRows = [
		{ label: `G&M Ethanol Cost Formula`, isTitle },

		{ label: PRIOR_DAY_LABEL, value: data.laEth },
		{ label: 'G&M Adder', value: adder },
		{ label: RACK_PRIOR_LABEL, value: laEth, isSubtotal },

		{ label: PROJECTED_LABEL, value: data.projectedMonthly.laEth },
		{ label: 'G&M Adder', value: adder },
		{ label: RACK_PROJ_LABEL, value: projectedMonthlyLaEth, isSubtotal },

		{ label: UP_TO_DATE_LABEL, value: data.upToDateMonthly?.laEth },
		{ label: 'G&M Adder', value: adder },
		{ label: RACK_UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, isSubtotal },
	];

	const priceRows = [
		{ label: PRIOR_DAY_LABEL, value: laEth, path: 'laEth' },
		{ label: PROJECTED_LABEL, value: projectedMonthlyLaEth, path: 'projectedMonthly.laEth' },
		{ label: UP_TO_DATE_LABEL, value: upToDateMonthlyLaEth, path: 'upToDateMonthly.laEth' },
	];

	return { formulaRows, priceRows };
};

export const calcRackFormula = ({ formulaKey, data }) => {
	if (formulaKey === 'kinergy') {
		return kinergy({ data });
	} else if (formulaKey === 'kinergyForBoyett') {
		return kinergyForBoyett({ data });
	} else if (formulaKey === 'opisFlat') {
		return opisFlat({ data });
	} else if (formulaKey === 'ncpSacramento') {
		return ncpSacramento({ data });
	} else if (formulaKey === 'ncpSanYsidro') {
		return ncpSanYsidro({ data });
	} else if (formulaKey === 'pdi') {
		return pdi({ data });
	} else if (formulaKey === 'gm') {
		return gm({ data });
	} else if (formulaKey === 'rpmg') {
		return rpmg({ data });
	} else {
		return {
			notImplemented,
			priceRows: [
				{ label: PRIOR_DAY_LABEL, value: 0, path: 'laEth' },
				{ label: PROJECTED_LABEL, value: 0, path: 'projectedMonthly.laEth' },
				{ label: UP_TO_DATE_LABEL, value: 0, path: 'upToDateMonthly.laEth' },
			],
			formulaRows: [
				{ label: `${formulaKey} Ethanol Cost Formula`, isTitle: true },
				{ label: `This rack formula has not been implemented yet.`, notImplemented },
			],
		};
	}
};

//
//- E85 formula
//

function _addUnl(p) {
	const {
		formulaRows,
		data,
		unlAdder,
		actualUnleadedFuelCostPerGallon,
		usePdi,
		useSacramento,
		useSacLow,
		useFresnoLow,
		useLaLow,
	} = p;

	let unlCost;
	if (actualUnleadedFuelCostPerGallon) {
		//- Unleaded
		unlCost = actualUnleadedFuelCostPerGallon;
		formulaRows.push({ label: 'Actual Unleaded Cost', value: unlCost, note: 'unlCost' });
	} else {
		//- Unleaded
		let unlRackCost;
		if (usePdi) {
			//unlRackCost = data.pdiUnleaded;
			unlRackCost = data.pdiUnleadedFormula;
			formulaRows.push({ label: 'LA PDI Rack Unleaded (formula)', value: unlRackCost });
		} else if (useSacramento) {
			unlRackCost = data.sacramentoUbdRackAvg;
			formulaRows.push({ label: 'Sacramento Carb 87 Rack Average', value: unlRackCost });
		} else if (useSacLow) {
			unlRackCost = data.sacramentoUbdRackLow;
			formulaRows.push({ label: 'Sacramento Carb 87 Rack Low', value: unlRackCost });
		} else if (useFresnoLow) {
			unlRackCost = data.fresnoUbdRackLow;
			formulaRows.push({ label: 'Fresno Carb 87 Rack Low', value: unlRackCost });
		} else if (useLaLow) {
			unlRackCost = data.losAngelesUbdRackLow;
			formulaRows.push({ label: 'Los Angeles Carb 87 Rack Low', value: unlRackCost });
		} else {
			if (!data.laUbdRackAvgClosing || data.ubdRackAvg >= data.laUbdRackAvgClosing) {
				unlRackCost = data.ubdRackAvg;
				formulaRows.push({ label: LA_UNL_RACK_AVG_OPENING, value: unlRackCost });
			} else {
				unlRackCost = data.laUbdRackAvgClosing;
				formulaRows.push({ label: LA_UNL_RACK_AVG_CLOSING, value: unlRackCost });
			}
		}

		if (usePdi) {
			unlCost = unlRackCost;
		} else {
			formulaRows.push({ label: 'LA Cap & Trade Midrange', value: data.capAtTheRack });
			formulaRows.push({ label: 'LA LCFS Cost', value: data.lcfsCost });
			unlCost = unlRackCost + data.capAtTheRack + data.lcfsCost;
		}
	}

	let unlSubtotal;
	if (unlAdder) {
		formulaRows.push({ label: 'Unleaded Adder', value: unlAdder, note: 'unlCost' });
		unlSubtotal = unlCost + unlAdder;
	} else {
		unlSubtotal = unlCost;
	}

	formulaRows.push({ label: 'Unleaded Subtotal', value: unlSubtotal, isSubtotal });
	return { unlSubtotal };
}

function _addPriorWeekSdUnl({ formulaRows, data, actualUnleadedFuelCostPerGallon }) {
	let unlCost;
	if (actualUnleadedFuelCostPerGallon) {
		//- Unleaded
		unlCost = actualUnleadedFuelCostPerGallon;
		formulaRows.push({ label: 'Actual Unleaded Cost', value: unlCost, note: 'unlCost' });
	} else {
		//- Unleaded
		/** @namespace data.priorWeek.sanDiegoUbdRackAvg */
		const unlRackCost = data.priorWeek.sanDiegoUbdRackAvg;
		formulaRows.push({ label: 'Prior Week San Diego Carb 87 Rack Average', value: unlRackCost });

		/** @namespace data.capAtTheRack */
		formulaRows.push({
			label: 'Prior Week LA Cap & Trade Midrange',
			value: data.priorWeek.capAtTheRack,
		});

		/** @namespace data.lcfsCost */
		formulaRows.push({ label: 'Prior Week LA LCFS Cost', value: data.priorWeek.lcfsCost });
		unlCost = unlRackCost + data.priorWeek.capAtTheRack + data.priorWeek.lcfsCost;
	}

	let unlSubtotal = unlCost;
	formulaRows.push({ label: 'Unleaded Subtotal', value: unlSubtotal, isSubtotal });
	return { unlSubtotal };
}

const kaManagementFormula = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'KA Management E85 Formula', isTitle });

	//- Ethanol
	const ethSubtotal = formatEthSubtotalWithoutLcfsFee({ data, formulaRows });

	//- Unleaded
	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.1;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });

	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	return { formulaRows, priceRows, e85Price };
};

const hsE85 = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'H&S E85 Formula', isTitle });
	//- Ethanol
	const laEth = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: data.laEth });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const rinCredit = data[currentRinField];
	formulaRows.push({ label: currentRinLabel, value: data[currentRinField] });

	const ethSubtotal = laEth - rinCredit;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.05;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	// formulaRows.push({ label : 'Freight per gallon', value : freightPerGallon});

	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		`- Updated on 8/8/2020 : Actual freight amount is entered on invoicing.`,
		`* Deprecated on 8/1/2020 : We should only be using H&S New (8/1) now`,
		`- Created 1/3/2019 : Formula is a derivative of KA Management but has a .05 adder instead of .10`,
	];
	return { formulaRows, priceRows, e85Price, formulaNotes };
};

const hsNew = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'H&S New (8/1) Formula', isTitle });
	//- Ethanol
	const laEth = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: data.laEth });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const rinCredit = data[currentRinField];
	formulaRows.push({ label: currentRinLabel, value: data[currentRinField] });

	const ethSubtotal = laEth - rinCredit;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.01;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	// formulaRows.push({ label : 'Freight per gallon', value : freightPerGallon});

	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		`- Updated on 8/8/2020 : Actual freight amount is entered on invoicing.`,
		`- Created 8/1/2020 : Formula is derived from H&S E85 formula and updated for new contract.`,
	];

	return { formulaRows, priceRows, e85Price, formulaNotes };
};

const au = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'AU Formula', isTitle });
	//- Ethanol
	const laEth = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: data.laEth });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const rinCredit = data[currentRinField];
	formulaRows.push({ label: currentRinLabel, value: data[currentRinField] });

	const ethSubtotal = laEth - rinCredit;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const logisticsCosts = 0.02;
	formulaRows.push({ label: 'Logistics Costs', value: logisticsCosts });
	// formulaRows.push({ label : 'Freight per gallon', value : freightPerGallon});

	const e85Price = ethBlend + unlBlend + logisticsCosts + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		`- Created from H&S New formula with .10 logistics costs instead of .01 pearson margin.`,
		`- 10/5/2025 : Changed adder from .10 to .02.`,
	];

	return { formulaRows, priceRows, e85Price, formulaNotes };
};

const mcrd = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'MCRD E85 Formula', isTitle });
	//- Ethanol
	const eth = data.priorWeek.laEth;
	formulaRows.push({ label: 'Prior Week Ethanol Cost', value: eth });

	//- Unl
	const { unlSubtotal } = _addPriorWeekSdUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
	});

	const ethBlend = eth * 0.75;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.75', value: ethBlend });

	const unlBlend = unlSubtotal * 0.25;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.25', value: unlBlend });

	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });

	const e85Price = ethBlend + unlBlend + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [`NOTE : MCRD formula uses the San Diego UBD UL Rack average`];

	return { formulaRows, priceRows, e85Price, formulaNotes };
};

const e85RetailContracted = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'E85 Retail (contracted) E85 Formula', isTitle });

	//- Ethanol
	const { ethCost, ethCostType } = getEthToUse(data);
	formulaRows.push({ label: `Ethanol Cost (${ethCostType})`, value: ethCost });

	let { rinCredit, rinCreditType, currentRinLabel } = getRinToUse(data);
	formulaRows.push({ label: `${currentRinLabel} (${rinCreditType})`, value: rinCredit });

	const rinDiscount = 0.18;
	formulaRows.push({ label: 'RIN Discount', value: rinDiscount });

	let ethSubtotal = ethCost - (rinCredit - rinDiscount);
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	let unlAdder = 0.31;
	const { unlSubtotal } = _addUnl({ data, formulaRows, unlAdder, actualUnleadedFuelCostPerGallon });

	//- Blend
	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.07;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });

	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const formulaNotes = [
		'Ethanol cost is either the projected monthly or previous day (whichever greater)',
		'RIN credit is the projected monthly or previous day (whichever less)',
		'9/1/2018 - Pearson margin bumped due to falling ethanol costs (.06 => .07)',
	];

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const ronAlfred = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'Ron/Alfred/Concord E85 Formula', isTitle });

	//- Ethanol
	const ethSubtotal = formatEthSubtotalWithoutLcfsFee({ data, formulaRows });

	//const ethCost = _higherLaEth(data);
	//formulaRows.push({ label: 'Ethanol Cost (High)', value: ethCost });

	//const currentRinField = getRinField(data);
	//const currentRinLabel = getRinLabel(currentRinField);
	//const rinCredit = _lowerRin(data);
	//formulaRows.push({ label: currentRinLabel, value: rinCredit });
	//const lcfsFee = formatLcfsFee({ data, formulaRows });

	//const ethSubtotal = ethCost - rinCredit + lcfsFee;

	let unlAdder = 0;
	const { unlSubtotal } = _addUnl({ data, formulaRows, unlAdder, actualUnleadedFuelCostPerGallon });

	//- Blend
	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.1;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });

	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const formulaNotes = [
		'11/12/18 - Used to be G&M Modified changed to Ron/Alfred/Concord',
		'10/24/2025 - Changed to spot, removed PDI, and LCFS Fee changes',
	];

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const e85RetailBakersfield = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'E85 Retail (bakersfield) E85 Formula', isTitle });

	//- Ethanol
	const { ethCost, ethCostType } = getEthToUse(data);
	formulaRows.push({ label: `Ethanol Cost (${ethCostType})`, value: ethCost });

	let { rinCredit, rinCreditType, currentRinLabel } = getRinToUse(data);
	formulaRows.push({ label: `${currentRinLabel} (${rinCreditType})`, value: rinCredit });

	const rinDiscount = 0.18;
	formulaRows.push({ label: 'RIN Discount', value: rinDiscount });

	let ethSubtotal = ethCost - (rinCredit - rinDiscount);
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	let unlAdder = 0.31;
	const { unlSubtotal } = _addUnl({ data, formulaRows, unlAdder, actualUnleadedFuelCostPerGallon });

	//- Blend
	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.07;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });

	const august15Moment = moment('2019-08-15');
	const daysDiff = moment().diff(august15Moment, 'days');
	let adder = daysDiff * 0.01;
	if (adder >= 0.15) {
		adder = 0.15;
	}
	formulaRows.push({ label: 'Extra Adder', value: adder });

	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon + adder;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const formulaNotes = [
		'Ethanol cost is either the projected monthly or previous day (whichever greater)',
		'RIN credit is the projected monthly or previous day (whichever less)',
		'9/1/2018 - Pearson margin bumped due to falling ethanol costs (.06 => .07)',
		'This is a clone of the E85 Retail (contracted) formula with an extra adder',
	];

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const dionAndSons = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Dion & Sons E85 Formula', isTitle });

	//- Ethanol
	const { ethCost, ethCostType } = getEthToUse(data);
	formulaRows.push({ label: `Ethanol Cost (${ethCostType})`, value: ethCost });

	let { rinCredit, rinCreditType, currentRinLabel } = getRinToUse(data);
	formulaRows.push({ label: `${currentRinLabel} (${rinCreditType})`, value: rinCredit });

	const rinDiscount = 0.18;
	formulaRows.push({ label: 'RIN Discount', value: rinDiscount });

	let ethSubtotal = ethCost - (rinCredit - rinDiscount);
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	let unlAdder = 0.31;
	const { unlSubtotal } = _addUnl({ data, formulaRows, unlAdder, actualUnleadedFuelCostPerGallon });

	//- Blend
	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.07;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const dionAndSonsAdder = 0.5;
	formulaRows.push({ label: 'Dion & Sons Adder', value: dionAndSonsAdder });

	const e85Price = ethBlend + unlBlend + pearsonMargin + dionAndSonsAdder;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const formulaNotes = [
		'Dion & Sons does not have freight charged.',
		`Formula is a derivative of E85 Retail (contracted) but does not include freight ` +
			`and has an additional .50 adder.`,
	];

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const falconFormula = (p) => {
	const {
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		//actualEthanolFuelCostPerGallon,
	} = p;
	//const freightPerGallon = p.freightPerGallon || 0;

	formulaRows.push({ label: 'Falcon E85 Formula', isTitle });

	//- Ethanol
	const ethCost = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: ethCost });

	const etohAdjustment = 0.15; // etoh adjustment
	formulaRows.push({ label: 'Ethanol Adjustment', value: etohAdjustment });

	const ethSubtotal = ethCost + etohAdjustment;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	//- unleaded
	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	//- Blend
	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const adjustment = -0.08;
	formulaRows.push({ label: 'Adjustment', value: adjustment });

	const e85Price = ethBlend + unlBlend + adjustment;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		'Falcon does not have freight blended into the E85 cost.',
		'Freight is billed as a separate line item on invoices.',
	];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const twentyNinePalmsFormula = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: '29 Palms E85 Formula', isTitle });

	//- Ethanol
	const ethCost = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: ethCost });

	const ethSubtotal = ethCost;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	//- unleaded
	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const e85Price = ethBlend + unlBlend;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		'29 Palms does not have freight blended into the E85 cost.',
		'Freight is billed as a separate line item on invoices.',
		'Prices do not include any taxes including the $.09 Vendor Use Tax that is to be paid when the E85 is dispensed into the vehicles.',
	];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const gmE85 = (p) => {
	const {
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		//actualEthanolFuelCostPerGallon,
	} = p;
	/** @namespace p.etohGallons */
	/** @namespace p.unlGallons */
	/** @namespace data.projectedMonthly.carbonIntensityEthanol */
	const freightPerGallon = p.freightPerGallon || 0;
	const etohGallons = p.etohGallons;
	const unlGallons = p.unlGallons;

	// I do the toFixed here because we do a toFixed on the backend for the rack
	const projectedEthanolCost = parseFloat(data.projectedMonthly.laEth.toFixed(5));

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const projectedRinsCost = data.projectedMonthly[currentRinField];

	formulaRows.push({ label: 'G&M E85 Formula', isTitle });

	//- Ethanol
	formulaRows.push({ label: 'Projected Ethanol Cost', value: projectedEthanolCost });
	formulaRows.push({ label: `Projected RINS (${currentRinLabel})`, value: projectedRinsCost });
	//formulaRows.push({ label: 'Projected LCFS CI Points', value: projectedLcfsCiPoints });
	const rinsDiscount = 0.02;
	formulaRows.push({ label: 'RINS Discount', value: rinsDiscount });

	// We took out the LCFS from the G&M formula on 7/24 for new contract
	// const projectedLcfsCiPoints = data.projectedMonthly.carbonIntensityEthanol;
	//const lcfsYearlyTarget = data.lcfsTarget || 88.25;
	//formulaRows.push({ label: 'Yearly LCFS Target', value: lcfsYearlyTarget });
	const ethSubtotal = projectedEthanolCost - (projectedRinsCost - rinsDiscount);
	//(lcfsYearlyTarget - 79.9) * projectedLcfsCiPoints;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	//- Unleaded
	const { unlSubtotal } = _addUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		usePdi: true,
	});

	let ethBlendPercent = 0.8335;
	let unlBlendPercent = 0.1665;

	if (etohGallons && unlGallons) {
		const totalGallons = etohGallons + unlGallons;

		formulaRows.push({ label: 'Ethanol Gallons', value: etohGallons });
		formulaRows.push({ label: 'Unleaded Gallons', value: unlGallons });
		ethBlendPercent = parseFloat((etohGallons / totalGallons).toFixed(5));
		unlBlendPercent = parseFloat((unlGallons / totalGallons).toFixed(5));
	}

	const ethBlend = ethSubtotal * ethBlendPercent;
	formulaRows.push({ label: `Ethanol Subtotal x ${ethBlendPercent}`, value: ethBlend });

	const unlBlend = unlSubtotal * unlBlendPercent;
	formulaRows.push({ label: `Unleaded Subtotal x ${unlBlendPercent}`, value: unlBlend });

	const pearsonMargin = 0.1;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });
	const e85Price = ethBlend + unlBlend + pearsonMargin + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		'On invoices the ethanol and unleaded blend percentage will be calculated based on actual delivered gallons.',
		'When not invoicing defaults of .8335 and .1665 are used for ethanol and unleaded.',
	];

	return { formulaRows, priceRows, e85Price, formulaNotes };
};

const boyettE85 = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Boyett E85 Formula', isTitle });

	//- Ethanol
	const ethCost = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: ethCost });

	const ethSubtotal = ethCost;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	//- unleaded
	const { unlSubtotal } = _addUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		useSacramento: true,
	});

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.1;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const e85Price = ethBlend + unlBlend + pearsonMargin;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		'Added 8/28/2019',
		'Uses Sacramento Carb 87 Rack Average',
		'Should always use the Kinergy for Boyett rack formula',
	];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const formula15SacLow = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Formula 15 (Sac Low) E85 Formula', isTitle });

	//- Ethanol
	const ethSubtotal = formatEthSubtotalWithoutLcfsFee({ data, formulaRows });

	//- unleaded
	const { unlSubtotal } = _addUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		useSacLow: true,
	});

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.15;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const e85Price = ethBlend + unlBlend + pearsonMargin;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		'Added 3/24/2020',
		'Uses Sacramento Carb 87 Rack Low',
		'Created for R098 - Tracy Contract',
	];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const formula15SacLowMinus025 = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Formula 15 (Sac Low Minus 0.025) E85 Formula', isTitle });

	//- Ethanol
	const ethSubtotal = formatEthSubtotalWithLcfsFee({ data, formulaRows });

	//- unleaded
	const { unlSubtotal } = _addUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		useSacLow: true,
	});

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.15;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const reduction = 0.025;
	formulaRows.push({ label: 'Price Reduction', value: reduction });

	const e85Price = ethBlend + unlBlend + pearsonMargin - reduction;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = ['Added 3/21/2022', 'Uses Sacramento Carb 87 Rack Low', 'Requested by Greg'];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

function formatLcfsFee({ data, formulaRows }) {
	const lcfsTarget = data.lcfsTarget || LCFS_TARGET;
	formulaRows.push({ label: 'LCFS Target', value: lcfsTarget });

	const lcfsStandard = data.lcfsStandard || LCFS_STANDARD;
	formulaRows.push({ label: 'LCFS Standard', value: lcfsStandard });

	const ciPoints = data.carbonIntensityEthanol;
	formulaRows.push({ label: 'Spot LCFS CI Points', value: ciPoints });

	const lcfsFee = (lcfsTarget - lcfsStandard) * ciPoints;
	formulaRows.push({
		label: 'LCFS Fee = (Target - Standard) * CI_Points',
		value: lcfsFee,
	});

	return lcfsFee;
}

// Bunnell
const fresnoLow = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Fresno Low (Bunnell) E85 Formula', isTitle });

	//- Ethanol
	const ethSpot = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: ethSpot });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const rinSpot = data[currentRinField];
	formulaRows.push({ label: currentRinLabel, value: rinSpot });
	//const lcfsFee = formatLcfsFee({ data, formulaRows });

	const ethSubtotal = ethSpot - rinSpot;
	formulaRows.push({
		label: 'Ethanol Subtotal (ETH - RIN)',
		value: ethSubtotal,
		isSubtotal,
	});

	//- unleaded
	const { unlSubtotal } = _addUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		useFresnoLow: true,
	});

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const e85Price = ethBlend + unlBlend;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		'Created 6/14/2023',
		'Uses Fresno Carb 87 Rack Low',
		'8 cents delivery adder is on station',
		'Requested by Greg for Bunnell',
	];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

function formatEthSubtotalWithLcfsFee({ data, formulaRows }) {
	const ethCost = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: ethCost });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const rinCredit = data[currentRinField];
	formulaRows.push({ label: currentRinLabel, value: data[currentRinField] });
	const lcfsFee = formatLcfsFee({ data, formulaRows });

	const ethSubtotal = ethCost - rinCredit + lcfsFee;
	formulaRows.push({
		label: 'Ethanol Subtotal (Eth - RIN + LCFS Fee)',
		value: ethSubtotal,
		isSubtotal,
	});
	return ethSubtotal;
}

function formatEthSubtotalWithoutLcfsFee({ data, formulaRows }) {
	const ethCost = data.laEth;
	formulaRows.push({ label: PRIOR_DAY_LABEL, value: ethCost });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);
	const rinCredit = data[currentRinField];
	formulaRows.push({ label: currentRinLabel, value: data[currentRinField] });

	const ethSubtotal = ethCost - rinCredit;
	formulaRows.push({
		label: 'Ethanol Subtotal (Eth - RIN)',
		value: ethSubtotal,
		isSubtotal,
	});
	return ethSubtotal;
}

const formula15 = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon, noLcfs } = p;

	if (noLcfs) {
		formulaRows.push({ label: 'Formula 15 (No LCFS) E85 Formula', isTitle });
	} else {
		formulaRows.push({ label: 'Formula 15 E85 Formula', isTitle });
	}

	//- Ethanol
	let ethSubtotal;
	if (noLcfs) {
		ethSubtotal = formatEthSubtotalWithoutLcfsFee({ data, formulaRows });
	} else {
		ethSubtotal = formatEthSubtotalWithLcfsFee({ data, formulaRows });
	}

	//- unleaded
	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.15;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const e85Price = ethBlend + unlBlend + pearsonMargin;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const formula15NoLcfs = (p) => {
	return formula15({ ...p, noLcfs: true });
};

const formula15LaLowNoLcfs = (p) => {
	return formula15LaLow({ ...p, noLcfs: true });
};

const formula15LaLow = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon, noLcfs } = p;

	if (noLcfs) {
		formulaRows.push({ label: 'Formula 15 (La Low, No LCFS) E85 Formula', isTitle });
	} else {
		formulaRows.push({ label: 'Formula 15 (La Low) E85 Formula', isTitle });
	}

	//- Ethanol
	let ethSubtotal;
	if (noLcfs) {
		ethSubtotal = formatEthSubtotalWithoutLcfsFee({ data, formulaRows });
	} else {
		ethSubtotal = formatEthSubtotalWithLcfsFee({ data, formulaRows });
	}

	//- unleaded
	const { unlSubtotal } = _addUnl({
		data,
		formulaRows,
		actualUnleadedFuelCostPerGallon,
		useLaLow: true,
	});

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.15;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const e85Price = ethBlend + unlBlend + pearsonMargin;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const formula15Msd3 = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Formula 15 MDS 2 E85 Formula', isTitle });

	//- Ethanol
	const ethSubtotal = formatEthSubtotalWithLcfsFee({ data, formulaRows });

	//- unleaded
	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.15;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const extraDiscount = -0.02;
	formulaRows.push({ label: 'Extra Discount', value: extraDiscount });

	const e85Price = ethBlend + unlBlend + pearsonMargin + extraDiscount;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [
		`- Updated 8/31/2020 : Formula name changed from Formula 15 MSD 3 to Formula MSD 2`,
		`- Created 8/28/2020 : Formula is a derivative of Formula 15 with an extra 3 cents off.`,
		`- 8/2/2020 Originally created to be used with Oil and Water stations.`,
	];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

const formula20 = (p) => {
	const { data, formulaRows, actualUnleadedFuelCostPerGallon } = p;

	formulaRows.push({ label: 'Formula 20 E85 Formula', isTitle });

	//- Ethanol
	const ethSubtotal = formatEthSubtotalWithLcfsFee({ data, formulaRows });
	//- unleaded
	const { unlSubtotal } = _addUnl({ data, formulaRows, actualUnleadedFuelCostPerGallon });

	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	const pearsonMargin = 0.2;
	formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });

	const e85Price = ethBlend + unlBlend + pearsonMargin;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	const formulaNotes = [];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

export const calcGasFormula = (p) => {
	const { data, formulaKey, rackFormulaKey } = p;

	//- Rack influences the ethanol cost
	const { formulaRows, priceRows } = calcRackFormula({ data, formulaKey: rackFormulaKey });
	const newData = _.cloneDeep(data);
	priceRows.forEach((row) => {
		_.set(newData, row.path, row.value);
	});

	p.data = newData;
	p.formulaRows = formulaRows;
	//const params = {formulaRows, data : newData, freightPerGallon, actualUnleadedFuelCostPerGallon};

	if (formulaKey === 'kaManagementFormula') {
		return kaManagementFormula(p);
	} else if (formulaKey === 'h&sE85') {
		return hsE85(p);
	} else if (formulaKey === 'h&sNew') {
		return hsNew(p);
	} else if (formulaKey === 'au') {
		return au(p);
	} else if (formulaKey === 'mcrdFormula') {
		return mcrd(p);
	} else if (formulaKey === 'e85RetailContracted') {
		return e85RetailContracted(p);
	} else if (formulaKey === 'e85RetailBakersfield') {
		return e85RetailBakersfield(p);
	} else if (formulaKey === 'dionAndSons') {
		return dionAndSons(p);
	} else if (formulaKey === 'falconFormula') {
		return falconFormula(p);
	} else if (formulaKey === '29Palms') {
		return twentyNinePalmsFormula(p);
	} else if (formulaKey === 'g&mE85') {
		return gmE85(p);
	} else if (formulaKey === 'g&mE85Modified') {
		return ronAlfred(p);
	} else if (formulaKey === 'boyettE85') {
		return boyettE85(p);
	} else if (formulaKey === 'formula15SacLow') {
		return formula15SacLow(p);
	} else if (formulaKey === 'formula15SacLowMinus025') {
		return formula15SacLowMinus025(p);
	} else if (formulaKey === 'fresnoLow') {
		return fresnoLow(p);
	} else if (formulaKey === 'formula15Msd3') {
		return formula15Msd3(p);
	} else if (formulaKey === 'formula15') {
		return formula15(p);
	} else if (formulaKey === 'formula15NoLcfs') {
		return formula15NoLcfs(p);
	} else if (formulaKey === 'formula15LaLow') {
		return formula15LaLow(p);
	} else if (formulaKey === 'formula15LaLowNoLcfs') {
		return formula15LaLowNoLcfs(p);
	} else if (formulaKey === 'formula20') {
		return formula20(p);
	} else {
		return {
			notImplemented,
			formulaRows: [
				{ label: `${formulaKey} E85 Formula`, isTitle: true },
				{ label: `This formula has not been implemented yet.`, notImplemented },
			],
		};
	}
};

export const calcNewGasFormula = (p) => {
	const { data, formulaKey } = p;

	if (formulaKey === 'newRetailFlat') {
		return newRetail({ data, modifier: 0 });
	} else if (formulaKey === 'newRetailPlus10') {
		return newRetail({ data, modifier: 0.1 });
	} else if (formulaKey === 'newRetailMinus10') {
		return newRetail({ data, modifier: -0.1 });
	} else {
		return {
			notImplemented,
			formulaRows: [
				{ label: `${formulaKey} E85 Formula`, isTitle: true },
				{ label: `This formula has not been implemented yet.`, notImplemented },
			],
		};
	}
};

const newRetail = (p) => {
	const { data, modifier } = p;
	const freightPerGallon = p.freightPerGallon || 0;

	const formulaRows = [];

	formulaRows.push({ label: 'OPIS Inputs', isTitle });

	formulaRows.push({
		label: 'Projected Monthly LA Ethanol Cost',
		value: data.projectedMonthly.laEth,
	});
	formulaRows.push({
		label: 'MTD Average LA Ethanol Cost',
		value: data.upToDateMonthly?.laEth,
	});
	formulaRows.push({ label: 'Latest Spot LA Month Ethanol Cost', value: data.laEth });

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);

	formulaRows.push({
		label: 'Projected Monthly RIN Credit',
		value: data.projectedMonthly[currentRinField],
	});
	formulaRows.push({
		label: 'MTD Average RIN Credit',
		value: data.upToDateMonthly[currentRinField],
	});
	formulaRows.push({ label: 'Latest Spot RIN Credit', value: data[currentRinField] });

	formulaRows.push({
		label: LA_UNL_RACK_AVG_OPENING,
		value: data.ubdRackAvg,
	});
	formulaRows.push({
		label: LA_UNL_RACK_AVG_CLOSING,
		value: data.laUbdRackAvgClosing,
	});

	// Retail
	formulaRows.push({ label: 'E85 Retail (flat)', isTitle });

	//- Ethanol
	const { ethCost, ethCostType } = getEthToUse(data);
	formulaRows.push({ label: `Ethanol Cost (${ethCostType})`, value: ethCost });

	// #PLC
	const pearsonLogisticsCost = data.pearsonLogisticsCost;
	formulaRows.push({ label: 'Pearson Logistics Cost', value: pearsonLogisticsCost });

	let { rinCredit, rinCreditType } = getRinToUse(data);

	//const rinCredit = _lowerRin(data);
	formulaRows.push({ label: `${currentRinLabel} (${rinCreditType})`, value: rinCredit });

	const RIN_DISCOUNT = 0.19;
	formulaRows.push({ label: 'RIN Discount', value: RIN_DISCOUNT });

	let ethSubtotal = ethCost + pearsonLogisticsCost - rinCredit + RIN_DISCOUNT;
	formulaRows.push({ label: 'Ethanol Subtotal', value: ethSubtotal, isSubtotal });

	const UNL_ADDER = 0.19;
	const { unlSubtotal } = _addUnl({ data, formulaRows, unlAdder: UNL_ADDER });

	//- Blend
	const ethBlend = ethSubtotal * 0.83;
	formulaRows.push({ label: 'Ethanol Subtotal x 0.83', value: ethBlend });

	const unlBlend = unlSubtotal * 0.17;
	formulaRows.push({ label: 'Unleaded Subtotal x 0.17', value: unlBlend });

	let pearsonMargin = 0.0;
	let pearsonDiscount = 0.0;

	if (modifier === 0) {
		formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
		formulaRows.push({ label: 'Pearson Discount', value: pearsonDiscount });
	} else if (modifier > 0) {
		pearsonMargin = modifier;
		formulaRows.push({ label: 'Pearson Margin', value: pearsonMargin });
	} else if (modifier < 0) {
		pearsonDiscount = modifier;
		formulaRows.push({ label: 'Pearson Discount', value: pearsonDiscount });
	}

	formulaRows.push({ label: 'Freight per gallon', value: freightPerGallon });

	const e85Price = ethBlend + unlBlend + pearsonMargin + pearsonDiscount + freightPerGallon;
	formulaRows.push({ label: 'E85 Price', value: e85Price, isTotal });

	const formulaNotes = [];

	const priceRows = [{ label: E85_PRICE_LABEL, value: e85Price, path: 'e85Price' }];

	return { formulaRows, priceRows, formulaNotes, e85Price };
};

//
//- BULK -----
//

const BULK_ETH_COST = 'Bulk Ethanol Price';

const bulkSeaport = ({ data }) => {
	const formulaRows = [];
	formulaRows.push({ label: 'Seaport Refining Bulk Formula', isTitle });

	if (_.isArray(data.prior3Day.sources)) {
		const sources = data.prior3Day.sources;
		sources.forEach((source) => {
			const { laEth, date } = source;
			const dateFormatted = moment(date).format('M/D');
			formulaRows.push({ label: `${dateFormatted} : OPIS LA Ethanol`, value: laEth });
		});
	}

	const currentRinField = getRinField(data);
	const currentRinLabel = getRinLabel(currentRinField);

	/** @namespace data.prior3Day */
	const threeDayWrapEth = data.prior3Day.laEth;
	formulaRows.push({ label: '3 Day Wrap OPIS LA', value: threeDayWrapEth, isSubtotal });

	if (_.isArray(data.prior3Day.sources)) {
		const sources = data.prior3Day.sources;
		sources.forEach((source) => {
			const { date } = source;
			const currentRinCredit = source[currentRinField];
			const dateFormatted = moment(date).format('M/D');
			formulaRows.push({ label: `${dateFormatted} : ${currentRinLabel}`, value: currentRinCredit });
		});
	}

	const threeDayWrapRin = data.prior3Day[currentRinField];
	formulaRows.push({ label: '3 Day Wrap RIN', value: threeDayWrapRin, isSubtotal });
	const halfOfThreeDayWrapRin = threeDayWrapRin * 0.5;
	formulaRows.push({ label: 'RIN Wrap x .5', value: halfOfThreeDayWrapRin, isSubtotal });

	formulaRows.push({ label: 'Ethanol Cost', value: threeDayWrapEth });
	formulaRows.push({ label: 'RIN Discount', value: -halfOfThreeDayWrapRin });

	const discount = 0.02;
	formulaRows.push({ label: 'Contract Discount', value: -discount });

	const bulkPrice = threeDayWrapEth - halfOfThreeDayWrapRin - discount;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	return { formulaRows, bulkPrice };
};

/** @namespace data.priorMonthLastDay */

const bulkBoyett = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'Boyett Bulk Formula', isTitle }];

	const priorMonthLastDay = data.priorMonthLastDay.laEth;
	formulaRows.push({ label: 'Last Day Prior Month', value: priorMonthLastDay });

	const adder = bulkAdderMap.boyett;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorMonthLastDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = ['6/30/2019 : Updated formula to Q3 2019 contract'];

	return { formulaRows, formulaNotes, bulkPrice };
};

const bulkIdemitsu = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'Idemitsu Bulk Formula', isTitle }];

	const priorMonthLastDay = data.priorMonthLastDay.laEth;
	formulaRows.push({ label: 'Last Day Prior Month', value: priorMonthLastDay });

	const adder = bulkAdderMap.idemitsu;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorMonthLastDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = ['Q1 2019 CONTRACT (EXPIRES 03/31/19)'];

	return { formulaRows, formulaNotes, bulkPrice };
};

const bulkRcp = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'Rcp Bulk Formula', isTitle }];

	const priorDay = data.laEth;
	formulaRows.push({ label: 'LA Spot Ethanol Cost', value: priorDay });

	const adder = bulkAdderMap.rcp;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = ['6/30/2019 : Updated formula to Q3 2019 contract'];

	return { formulaRows, formulaNotes, bulkPrice };
};

const bulkScFuels = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'SC Fuels Bulk Formula', isTitle }];

	const priorMonthLastDay = data.priorMonthLastDay.laEth;
	formulaRows.push({ label: 'Last Day Prior Month', value: priorMonthLastDay });

	const adder = bulkAdderMap.scFuels;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorMonthLastDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = [
		'STILL COLLOQUIALLY KNOWN AS "SOCO GROUP"',
		'6/30/2019 : Updated formula to Q3 2019 contract',
		'10/01/2019 : Updated formula to : SCF-091119-KMMV-Q419-Ethanol(S)',
	];

	return { formulaRows, formulaNotes, bulkPrice };
};

const bulkMusketMissionValley = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'Musket Mission Valley Bulk Formula', isTitle }];

	const priorMonthLastDay = data.priorMonthLastDay.laEth;
	formulaRows.push({ label: 'Last Day Prior Month', value: priorMonthLastDay });

	const adder = bulkAdderMap.musketMissionValley;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorMonthLastDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = [`Musket's new contract for 03/15 - 06/30/19`];

	return { formulaRows, formulaNotes, bulkPrice };
};

const bulkMusketColton = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'Musket Colton Bulk Formula', isTitle }];

	const priorMonthLastDay = data.priorMonthLastDay.laEth;
	formulaRows.push({ label: 'Last Day Prior Month', value: priorMonthLastDay });

	const adder = bulkAdderMap.musketColton;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorMonthLastDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = [`Musket's new contract for 03/15 - 06/30/19`];

	return { formulaRows, formulaNotes, bulkPrice };
};

const bulkShell = ({ data }) => {
	const bulkAdderMap = getBulkAdderMap(data);
	const formulaRows = [{ label: 'Shell Bulk Formula', isTitle }];

	const priorMonthLastDay = data.priorMonthLastDay.laEth;
	formulaRows.push({ label: 'Last Day Prior Month', value: priorMonthLastDay });

	const adder = bulkAdderMap.shell;
	formulaRows.push({ label: 'Adder', value: adder });

	const bulkPrice = priorMonthLastDay + adder;
	formulaRows.push({ label: BULK_ETH_COST, value: bulkPrice, isTotal });

	const formulaNotes = [
		'6/30/2019 : New formula based on Q3 2019 contract',
		'7/12/2019 : New -.20 adder added as it was missed in the original contract',
	];
	return { formulaRows, formulaNotes, bulkPrice };
};

export const calcBulkFormula = ({ bulkFormulaKey, data }) => {
	if (bulkFormulaKey === 'seaportRefining') {
		return bulkSeaport({ data });
	} else if (bulkFormulaKey === 'boyett') {
		return bulkBoyett({ data });
	} else if (bulkFormulaKey === 'idemitsu') {
		return bulkIdemitsu({ data });
	} else if (bulkFormulaKey === 'idemitsu') {
		return bulkIdemitsu({ data });
	} else if (bulkFormulaKey === 'rcp') {
		return bulkRcp({ data });
	} else if (bulkFormulaKey === 'scFuels') {
		return bulkScFuels({ data });
	} else if (bulkFormulaKey === 'musketMissionValley') {
		return bulkMusketMissionValley({ data });
	} else if (bulkFormulaKey === 'musketColton') {
		return bulkMusketColton({ data });
	} else if (bulkFormulaKey === 'shell') {
		return bulkShell({ data });
	} else {
		return {
			notImplemented,
			formulaRows: [
				{ label: `${bulkFormulaKey} Bulk Price Formula`, isTitle: true },
				{ label: `This bulk formula has not been implemented yet.`, notImplemented },
			],
		};
	}
};

//
//- Biodiesel
//

const BIODIESEL_COST = 'Biodiesel Price';
const biodieselEnpcRefinedResources = ({ data }) => {
	const formulaRows = [{ label: 'ENPC Refined Resources', isTitle }];

	const biodieselSettlement = data.biodieselSettlement;
	formulaRows.push({ label: 'CMEGroup Settlement Price', value: biodieselSettlement });

	const adjustment = -0.88;
	formulaRows.push({ label: 'Negotiated Adjustment', value: adjustment });

	const biodieselPrice = biodieselSettlement + adjustment;
	formulaRows.push({ label: BIODIESEL_COST, value: biodieselPrice, isTotal });

	const formulaNotes = [];
	return { formulaRows, formulaNotes, biodieselPrice };
};

const biodieselLostHillsTravelCenter = ({ data }) => {
	const formulaRows = [{ label: 'Lost Hills Travel Center', isTitle }];

	/** @namespace data.biodieselSettlement */
	const biodieselSettlement = data.biodieselSettlement;
	formulaRows.push({ label: 'CMEGroup Settlement Price', value: biodieselSettlement });

	const adjustment = -0.77;
	formulaRows.push({ label: 'Negotiated Adjustment', value: adjustment });

	const biodieselPrice = biodieselSettlement + adjustment;
	formulaRows.push({ label: BIODIESEL_COST, value: biodieselPrice, isTotal });

	const formulaNotes = [];
	return { formulaRows, formulaNotes, biodieselPrice };
};

//Changed on 2021-10-24 -- OLD
/*
const fobParamountRd8020 = ({ data }) => {
	const formulaRows = [{ label: 'FOB Paramount RD80/20', isTitle }];
	const laCarbNo2DieselSpotAvg = data.laCarbNo2DieselSpotAvg;
	formulaRows.push({ label: 'LA Diesel Spot Carb No. 2', value: laCarbNo2DieselSpotAvg });

	// const caCiDailyBdAvg = data.caCiDailyBdAvg;
	// formulaRows.push({ label : 'CA Daily BD Posting', value : caCiDailyBdAvg });

	const caCarCarbNo2Avg = data.caCarCarbNo2Avg;
	formulaRows.push({ label: 'Cap at the Rack Carb No2 Average', value: caCarCarbNo2Avg });

	const caLcfsCarbDieselAvg = data.caLcfsCarbDieselAvg;
	formulaRows.push({ label: 'CA LCFS Carb Diesel Average', value: caLcfsCarbDieselAvg });

	const carbonDieselDeficitAvg = data.carbonDieselDeficitAvg;
	formulaRows.push({ label: 'CGP Diesel Crud Deficit Average', value: carbonDieselDeficitAvg });

	const adjustment = -0.1;
	formulaRows.push({ label: 'Adjustment', value: adjustment });

	const freight = 0.0;
	formulaRows.push({ label: 'Full/Split/Half Freight', value: freight });

	const biodieselPrice =
		laCarbNo2DieselSpotAvg +
		caCarCarbNo2Avg +
		caLcfsCarbDieselAvg +
		carbonDieselDeficitAvg +
		adjustment;
	formulaRows.push({ label: BIODIESEL_COST, value: biodieselPrice, isTotal });

	const formulaNotes = [];
	return { formulaRows, formulaNotes, biodieselPrice };
};
*/

//- NEW
const fobParamountRd8020 = ({ data }) => {
	const formulaRows = [{ label: 'FOB Paramount RD80/20', isTitle }];
	const laDieselUnbrandedAvgWithCarClosing = data.laDieselUnbrandedAvgWithCarClosing;
	formulaRows.push({
		label: 'LA Diesel Unbranded Average with Car (Closing',
		value: laDieselUnbrandedAvgWithCarClosing,
	});

	const adder = 0.14;
	formulaRows.push({ label: 'World Energy Adder', value: adder });

	const discount = 0.11;
	formulaRows.push({ label: 'Customer Discount', value: discount });

	const freight = 0.0;
	formulaRows.push({ label: 'Full/Split/Half Freight', value: freight });

	const biodieselPrice = laDieselUnbrandedAvgWithCarClosing + adder - discount;
	formulaRows.push({ label: BIODIESEL_COST, value: biodieselPrice, isTotal });

	const formulaNotes = [];
	return { formulaRows, formulaNotes, biodieselPrice };
};

export const calcBiodieselFormula = ({ biodieselFormulaKey, data }) => {
	if (biodieselFormulaKey === 'enpcRefinedResources') {
		return biodieselEnpcRefinedResources({ data });
	} else if (biodieselFormulaKey === 'lostHillsTravelCenter') {
		return biodieselLostHillsTravelCenter({ data });
	} else if (biodieselFormulaKey === 'fobParamountRd8020') {
		return fobParamountRd8020({ data });
	} else {
		return {
			notImplemented,
			formulaRows: [
				{ label: `${biodieselFormulaKey} Biodiesel Price Formula`, isTitle: true },
				{ label: `This biodiesel formula has not been implemented yet.`, notImplemented },
			],
		};
	}
};
